import { Col, Row, Typography } from "antd";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import constants from "../Redux/constants";
import {
  StyledButton,
  StyledLink,
  StyledTag,
  StyledText,
  StyledTitle,
} from "../styled-components/components";
import { ClockCircleOutlined } from "@ant-design/icons";

const JobCard = (props) => {
  let history = useHistory();
  const {
    id,
    title,
    typeRequirement,
    createdDate,
    applicationsCount,
    showApplication,
    additionalComments,
    t24Release,
  } = props;
  const { userRole } = useSelector((state) => state.userStore);
  const createdAt = (createdDate) => {
    return moment.utc(createdDate).from(moment());
  };
  const goToPage = () => {
    history.push(`/job/${id}`);
  };
  const clientViewApplications = () => {
    history.push(`/client/${id}/applications`);
  };
  const consultantViewApplication = () => {
    history.push(`/consultant/application/${id}`);
  };
  const clientViewJob = () => {
    history.push(`/client/job/${id}`);
  };
  return (
    <Col>
      <Col
        md={{ span: 11 }}
        style={{
          padding: "1vh",
          background: "#ffffff",
          border: "1px solid #f4f4f4",
          margin: "2vh",
          marginLeft: "auto",
          marginRight: "auto",
          borderRadius: "2vh",
        }}
      >
        <Col style={{ padding: "1vh" }}>
          <Row justify="space-between">
            <Col xl={{ span: 20 }}>
              <Row justify="space-between">
                <Col xl={{ span: 24 }}>
                  <StyledTitle textColor="#e7315a" onClick={goToPage} level={5}>
                    {title}
                  </StyledTitle>
                  <Col>
                    <ClockCircleOutlined /> {createdAt(createdDate)}
                  </Col>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row style={{ margin: "1vh" }}>
            {additionalComments ? (
              <Typography.Paragraph
                ellipsis={
                  additionalComments.length > 20
                    ? {
                        rows: 1.5,
                        expandable: true,
                        symbol: (
                          <StyledText textColor="#1565d8">more</StyledText>
                        ),
                      }
                    : false
                }
              >
                {additionalComments}
              </Typography.Paragraph>
            ) : null}
          </Row>
          <Row justify="space-between" align="middle">
            <Col>
              <Row justify="space-between">
                <Col>
                  <StyledTag>{typeRequirement}</StyledTag>
                </Col>
                <Col>
                  {t24Release ? <StyledTag>{t24Release}</StyledTag> : null}
                </Col>
              </Row>
            </Col>
            <Col xl={{ span: 15 }}>
              {userRole === constants.roles.client ? (
                <ClientActions
                  clientViewApplications={clientViewApplications}
                  applicationsCount={applicationsCount}
                  goToPage={goToPage}
                  clientViewJob={clientViewJob}
                />
              ) : null}
              {userRole === constants.roles.consultant ? (
                <ConsultantActions
                  showApplication={showApplication}
                  consultantViewApplication={consultantViewApplication}
                  goToPage={goToPage}
                />
              ) : null}
            </Col>
          </Row>
        </Col>
      </Col>
    </Col>
  );
};

// view no.of applications,edit job, view job

const ClientActions = ({
  applicationsCount,
  clientViewApplications,
  goToPage,
  clientViewJob,
}) => {
  return (
    <Col xl={{ span: 24 }}>
      <Row align="middle" justify="space-between">
        <Col>
          {applicationsCount >= 1 ? (
            <StyledLink
              onClick={clientViewApplications}
              data-testid="submit-applications"
            >
              View Applications : {applicationsCount}
            </StyledLink>
          ) : null}
        </Col>
        <Col>
          <StyledButton onClick={goToPage} data-testid="submit-editJob">
            Edit Job
          </StyledButton>
        </Col>
        <Col>
          <StyledButton onClick={clientViewJob} data-testid="submit-viewJob">
            View Job
          </StyledButton>
        </Col>
      </Row>
    </Col>
  );
};

// show Application,apply job

const ConsultantActions = ({
  showApplication,
  consultantViewApplication,
  goToPage,
}) => {
  return (
    <Col xl={{ span: 24 }}>
      <Row justify="end">
        <Col>
          {showApplication ? (
            <StyledLink
              onClick={consultantViewApplication}
              data-testid="submit-applications"
            >
              View Application
            </StyledLink>
          ) : (
            <Col>
              <Col xl={{ span: 5 }}>
                <StyledButton onClick={goToPage} data-testid="submit-viewJob">
                  View Job
                </StyledButton>
              </Col>
            </Col>
          )}
        </Col>
      </Row>
    </Col>
  );
};

export default JobCard;
